import React, { useState } from 'react';
import { ExternalLink } from '../router';
import { SOCIAL } from '../links';
import { useOpenNewsletter } from '../newsletter';
import HerbGallery from '../components/HerbGallery';
import MonthlyWorkshop from '../components/MonthlyWorkshop';
import GhlFormModal, { GHL_FORMS } from '../components/GhlFormModal';

const Resources: React.FC = () => {
  const openNewsletter = useOpenNewsletter();
  const [guidesOpen, setGuidesOpen] = useState(false);

  return (
    <>
      <section className="section page-hero">
        <div className="container container--narrow center">
          <h1>Resources</h1>
        </div>
      </section>

      <MonthlyWorkshop />

      <section className="section" id="guides">
        <div className="container container--narrow">
          <h2>Complimentary Guides</h2>
          <ul className="list">
            <li>
              <strong>Your Nervous System Under Load</strong> — a 2-minute self-assessment: are you regulated, under strain, or
              overloaded, with next steps for each.
            </li>
            <li>
              <strong>The Context Switching Tax</strong> — what constant task-switching is costing your focus, and a 3-step fix.
            </li>
          </ul>
          <button className="btn btn-primary" onClick={() => setGuidesOpen(true)}>
            Get the Guides
          </button>
        </div>
      </section>

      <section className="section section--alt" id="focus-reboot">
        <div className="container container--narrow">
          <h2>The Focus Reboot</h2>
          <p>
            Lost the focus you used to have? <strong>Five days, 20 minutes a day, 1:1</strong>, to find what is draining it and
            apply one real change, adjusted to you.
          </p>
          <p>
            <em>Free, with a $50 refundable deposit. Limited places each month.</em>
          </p>
          <ExternalLink href="https://focus-ntap.hannakinez.com/#apply" className="btn btn-primary">
            Apply for the Focus Reboot
          </ExternalLink>
        </div>
      </section>

      <section className="section" id="videos">
        <div className="container container--narrow">
          <h2>Videos</h2>
          <ul className="link-list">
            <li>
              <ExternalLink href="https://www.youtube.com/watch?v=eT4DJxDcM3c">A quick technique you can use today</ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.youtube.com/watch?v=S_qh-4ealcQ&list=PLitmEkEcCEIKj1R1AT0JmVzeuwhoSMp_0&index=1">
                Productivity Blueprint Workshop (series)
              </ExternalLink>
            </li>
          </ul>
          <p>
            YouTube channel: <ExternalLink href={SOCIAL.youtube}>Hanna Kinez · KinezioSomatic</ExternalLink>
          </p>
        </div>
      </section>

      <section className="section section--base" id="boost-calls">
        <div className="container container--narrow">
          <h2>Productivity Boost Calls — Coming Soon</h2>
          <p>
            Short, live <strong>15-minute calls, three times a week</strong>, to reset your focus and energy mid-week.{' '}
            <strong>Launching soon.</strong> Subscribe to the KinezioLetter to get the schedule and your invite first.
          </p>
          <button className="btn btn-primary" onClick={openNewsletter}>
            Notify Me
          </button>
        </div>
      </section>

      <HerbGallery />

      <section className="section section--dark" id="kinezioletter">
        <div className="container container--narrow center">
          <h2>The KinezioLetter</h2>
          <p>The tools, protocols, and body hacks I use with private clients, in your inbox.</p>
          <p className="small-print">No fluff. Unsubscribe anytime.</p>
          <button className="btn btn-primary" onClick={openNewsletter}>
            Subscribe to the KinezioLetter
          </button>
        </div>
      </section>

      <GhlFormModal
        isOpen={guidesOpen}
        onClose={() => setGuidesOpen(false)}
        form={GHL_FORMS.guides}
        title="Get Your Two Free Guides"
        intro={
          <>
            <strong>Your Nervous System Under Load</strong> and <strong>The Context Switching Tax</strong>, straight to your
            inbox.
          </>
        }
      />
    </>
  );
};

export default Resources;
